import useFetch from "../../hooks/useFetch";
import "./featuredProperties.css";

const FeaturedProperties = () => {
  const { data, loading, error } = useFetch("/hotels?featured=true&limit=4");

  return (
    <div className="fp">
      {loading ? (
        "Loading"
      ) : (
        <>
          {data.map((item) => (
            <div className="fpItem" key={item._id}>
              <img
                src={item.photos[0]}
                alt=""
                className="fpImg"
              />
              <div className="fpContent">
                <div className="fpBackground"></div>
                <span className="fpName">{item.name}</span>
                <span className="fpCity">{item.city}</span>
                <span className="fpPrice">Starting from ${item.cheapestPrice}</span>
                {item.rating && <div className="fpRating">
                  <button>{item.rating}</button>
                  <span>Excellent</span>
                </div>}
              </div>
              <div className="choiceDiv">
                <div className="resortCoice"><p>Resort Paradise's <span>Choice</span> </p></div>
                <div class="skew"></div>
              </div>
            </div>
            
          ))}
        </>
      )}
    </div>
  );
};

export default FeaturedProperties;
